import { Component, OnInit, ViewContainerRef, ViewChild, OnDestroy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { TeamAddComponent } from 'src/app/teams/team-add/team-add.component';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import { BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidenav-container',
  templateUrl: './sidenav-container.component.html',
  styleUrls: ['./sidenav-container.component.scss'],
})
export class SidenavContainerComponent implements OnInit {
  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  dialogRef: MatDialogRef<TeamAddComponent>;
  toggleSidenavSub: Subscription;

  constructor(
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    private responsiveService: ResponsiveService
  ) {}

  ngOnInit() {
    this.toggleSidenavSub = this.responsiveService.toggleSidenavEvent.subscribe(() => {
      this.sidenav.toggle();
    });
  }

  openDialog() {
    this.dialogRef = this.dialog.open(TeamAddComponent, {
      viewContainerRef: this.viewContainerRef,
    });

    this.dialogRef.afterClosed().subscribe((result) => {
      this.dialogRef = null;
    });
  }

  ngOnDestroy() {
    this.toggleSidenavSub.unsubscribe();
  }
}
